// extracted by mini-css-extract-plugin
export var standaloneTable = "_fl-0";
export var standaloneTableWithBodyFill = "_fl-1";
export var withExtraHeader = "_fl-2";